import React, {useState, useEffect} from "react";
import Swal from "sweetalert2";
import {Container} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {
    englishUser,
    sinhalaUser,
    tamilUser,
} from "../../../dummyData/getLearnersDetailsFormData";
import {cities} from "../../../dummyData/cities";
import {db} from "../../../firebase/firebase";
import {collection, addDoc, serverTimestamp} from "firebase/firestore";
import {ref, uploadBytesResumable, getDownloadURL} from "firebase/storage";
import {storage} from "../../../firebase/firebase";
import SingleImagePicker from "../../../Components/SingleImagePicker";
import {toast} from "react-toastify";

const GetLearnersDetailsForm = () => {

    const navigate = useNavigate();
    const selectedLanguage = useSelector((state) => state.language.language);
    const [language, setLanguage] = useState(sinhalaUser);
    const [cityList, setCityList] = useState([]);
    const [errors, setErrors] = useState({});
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [progress, setProgress] = useState(0);
    const [url, setUrl] = useState("");

    //   const [showOwnerWelcomeModal, setShowOwnerWelcomeModal] = useState(false);
    const [ownerData, setOwnerData] = useState({
        name: "",
        description: "",
        hotLine: "",
        services: [],
        prices: [{type: "", price: ""}],
        branches: [
            {
                branchName: "",
                branchAddress: "",
                branchContactNum: [""],
                email: "",
                regNo: "",
                district: "",
                city: "",
            },
        ],
    });

    useEffect(() => {
        switch (selectedLanguage.value) {
            case "english":
                setLanguage(englishUser);
                break;
            case "tamil":
                setLanguage(tamilUser);
                break;
            default:
                setLanguage(sinhalaUser);
                break;
        }
    }, [selectedLanguage]);

    const handleInputChange = (
        e,
        index,
        section,
        key = null,
        phoneIndex = null
    ) => {
        const {id, value, name, type} = e.target;

        if (type === "radio") {
            setOwnerData({...ownerData, [name]: value});
        } else if (section) {
            const updatedSection = [...ownerData[section]];
            if (id === "branchContactNum" && phoneIndex !== null) {
                const updatedNumbers = [...updatedSection[index].branchContactNum];
                updatedNumbers[phoneIndex] = value;
                updatedSection[index] = {
                    ...updatedSection[index],
                    branchContactNum: updatedNumbers,
                };
            } else {
                updatedSection[index] = {
                    ...updatedSection[index],
                    [key || id]: value,
                };
            }
            setOwnerData({...ownerData, [section]: updatedSection});
        } else {
            setOwnerData({...ownerData, [id]: value});
        }

        if (id === "district") {
            const selectedCities = cities[value]?.cities || [];
            setCityList(selectedCities);
            setOwnerData((prevState) => ({
                ...prevState,
            }));
        }
    };

    //   const handleAddService = () => {
    //     setOwnerData({
    //       ...ownerData,
    //       services: [...ownerData.services, { name: "", image: "" }],
    //     });
    //   };

    //   const handleRemoveService = (index) => {
    //     const services = [...ownerData.services];
    //     services.splice(index, 1);
    //     setOwnerData({ ...ownerData, services });
    //   };

    const handleAddPrice = () => {
        setOwnerData({
            ...ownerData,
            prices: [...ownerData.prices, {type: "", price: ""}],
        });
    };

    const handleRemovePrice = (index) => {
        const prices = [...ownerData.prices];
        prices.splice(index, 1);
        setOwnerData({...ownerData, prices});
    };

    const handleAddBranch = () => {
        setOwnerData({
            ...ownerData,
            branches: [
                ...ownerData.branches,
                {
                    branchName: "",
                    branchAddress: "",
                    branchContactNum: [""],
                    email: "",
                    regNo: "",
                    district: "",
                    city: "",
                },
            ],
        });
    };

    const handleRemoveBranch = (index) => {
        const branches = [...ownerData.branches];
        branches.splice(index, 1);
        setOwnerData({...ownerData, branches});
    };

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!ownerData.name || ownerData.name.trim().length === 0) {
            formErrors.name = "Name is required";
            isValid = false;
        }

        const wordCount = ownerData.description?.trim().split(/\s+/).length || 0;
        if (!ownerData.description || wordCount < 40 || wordCount > 100) {
            formErrors.description = "Description must be between 40 to 100 words";
            isValid = false;
        }

        const phoneRegex = /^(?:0\d{9})$/;
        //const phoneRegex = /^(011|021|031|041|051|061|071|081|091)\d{7}$/;

        if (!ownerData.hotLine || !phoneRegex.test(ownerData.hotLine)) {
            formErrors.hotLine = "Enter a valid 10-digit Sri Lankan phone number";
            isValid = false;
        }

        ownerData.branches.forEach((branch, i) => {
            branch.branchContactNum.forEach((num, j) => {
                if (!phoneRegex.test(num)) {
                    formErrors[`branch_${i}_phone_${j}`] =
                        "Enter a valid 10-digit Sri Lankan phone number";
                    isValid = false;
                }
            });
        });

        const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
        ownerData.branches.forEach((branch, i) => {
            if (!branch.email || !emailRegex.test(branch.email)) {
                formErrors[`branches.${i}.email`] =
                    "Enter a valid branch email address";
                isValid = false;
            }
        });

        

        if (!ownerData.services?.[0]?.name?.trim()) {
            formErrors.services = "At least one service is required";
            isValid = false;
        }

        if (!ownerData.prices?.[0]?.type?.trim()) {
            formErrors.prices = "At least one price is required";
            isValid = false;
        }

        if (!ownerData.branches?.[0]?.branchName?.trim()) {
            formErrors.branches = "At least one branch is required";
            isValid = false;
        }

        ownerData.branches.forEach((branch, i) => {
  if (!branch.branchName || !branch.branchName.trim()) {
    formErrors[`branch_${i}_name_0`] = "Branch name is required";
    isValid = false;
  }
  if (!branch.branchAddress || !branch.branchAddress.trim()) {
    formErrors[`branch_${i}_address_0`] = "Branch address is required";
    isValid = false;
  }
  if (
    !branch.branchContactNum[0] ||
    (!branch.branchContactNum[0].trim() && !phoneRegex.test(branch.branchContactNum))
  ) {
    formErrors[`branch_${i}_phone_0`] = "Branch contact number is required";
    isValid = false;
  }
  if (
    !branch.branchContactNum[1] ||
    (!branch.branchContactNum[1].trim() && !phoneRegex.test(branch.branchContactNum[1]))
  ) {
    formErrors[`branch_${i}_phone_1`] = "Branch contact number is required";
    isValid = false;
  }
  if (!branch.email || !branch.email.trim()) {
    formErrors[`branch_${i}_email_0`] = "Branch email is required";
    isValid = false;
  }
  // if (!branch.regNo || !branch.regNo.trim() && !regNumRegex.test(branch.regNo)) {
  //   formErrors[`branch_${i}_regNo_0`] = "Branch registration number is required";
  //   isValid = false;
  // }
  const regNumRegex = /^DL-\d{3}$/;

  
    if (!branch.regNo || !regNumRegex.test(branch.regNo)) {
      formErrors[`branch_${i}_regNo_0`] =
        "Enter a valid registration number (Format: DL-123)";
      isValid = false;
    }
  if (!branch.district || !branch.district.trim()) {
    formErrors[`branch_${i}_district_0`] = "Branch district is required";
    isValid = false;
  }
  if (!branch.city || !branch.city.trim()) {
    formErrors[`branch_${i}_city_0`] = "Branch city is required";
    isValid = false;
  }
});

        setErrors(formErrors);
        return isValid;
    };

    const handleChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(e.target.files[0]);
            if (file) {
                setImagePreview({
                    file: file,
                    preview: URL.createObjectURL(file),
                });
            }
            console.log("Image uploaded successfully:", image);
        }
    };

    const handleUpload = () => {
        return new Promise((resolve, reject) => {
            if (!image) {
                reject("No image selected");
                return;
            }

            const fileName = `${Date.now()}-${image.name}`;
            const storageRef = ref(storage, `images/${fileName}`);
            const uploadTask = uploadBytesResumable(storageRef, image);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress(progress);
                },
                (error) => {
                    console.log(error);
                    alert(error.message);
                    reject(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        setUrl(downloadURL);
                        // alert("Upload Successful");
                        resolve(downloadURL);
                    });
                }
            );
            // console.log("Image uploaded successfully:", image);
            // console.log("Image URL:", url);
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!image) {
            toast.warning("Please upload an image");
            return;
        }

        if (validateForm()) {
            try {
                const downloadURL = await handleUpload();

                await addDoc(collection(db, "drivingSchools"), {
                    ...ownerData,
                    createdAt: serverTimestamp(),
                    image: downloadURL,
                    permission: false
                });
                console.log("Owner Data:", ownerData);
                Swal.fire({
                    title: "Success",
                    text: language.successMsg,
                    icon: "success",
                    confirmButtonText: "OK",
                }).then(() => {
                    navigate("/find-and-register-driving-schools");
                });
                setOwnerData({
                    name: "",
                    description: "",
                    hotLine: "",
                    services: [{id: null, name: ""}],
                    prices: [{type: "", price: ""}],
                    branches: [
                        {
                            branchName: "",
                            branchAddress: "",
                            branchContactNum: [""],
                            email: "",
                            regNo: "",
                            district: "",
                            city: "",
                        },
                    ],
                });
                setUrl("");
                setImage(null);
                setProgress(0);
            } catch (error) {
                console.error("Error adding document: ", error);
                Swal.fire({
                    title: "Error",
                    text: "Failed to submit data. Please try again later.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                throw error;
            }
        }
    };

   return (
     <div className="gld-bg py-4 py-lg-5">
       <Container className="px-3 px-lg-4">
         {/* Header */}
         <div className="d-flex align-items-center gap-2 mb-3">
           <button
             onClick={() => navigate(-1)}
             className="btn btn-light rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center"
             style={{ width: 42, height: 42 }}
             type="button"
           >
             <i className="bi bi-arrow-left fs-5"></i>
           </button>

           <div>
             <h3 className="fs-3 text-dark mb-0 mb-lg-3 mb-md-1">
               {language.formTitleFirst}{" "}
               <span className="text-warning fw-bold">
                 {language.formTitleSecond}
               </span>
             </h3>
             <small className="text-muted">{language.validMsg}</small>
           </div>
         </div>

         {/* Main Card */}
         <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
           <div className="card-body p-3 p-md-4 p-lg-5">
             <form className="row g-3 g-lg-4" onSubmit={handleSubmit}>
               {/* Image */}
               <div className="col-12">
                 <div className="gld-section">
                   <div className="d-flex align-items-start justify-content-between gap-3">
                     <div>
                       <h6 className="mb-1 fw-bold">{language.logodes}</h6>
                       <small className="text-muted">
                         Upload a clear logo (PNG/JPG)
                       </small>
                     </div>
                     {progress > 0 && progress < 100 && (
                       <span className="badge text-bg-warning">
                         {Math.round(progress)}%
                       </span>
                     )}
                   </div>

                   <div className="mt-3">
                     <SingleImagePicker
                       handleChange={handleChange}
                       handleUpload={handleUpload}
                       progress={progress}
                       url={url}
                       image={image}
                       imagePreview={imagePreview?.preview}
                     />
                   </div>
                 </div>
               </div>

               {/* Basic Info */}
               <div className="col-12">
                 <div className="gld-section">
                   <div className="row g-3">
                     {/* Name */}
                     <div className="col-12 col-md-6">
                       <label htmlFor="name" className="form-label fw-semibold">
                         {language?.name}
                       </label>
                       <input
                         type="text"
                         className={`form-control gld-input ${
                           errors.name ? "is-invalid" : ""
                         }`}
                         id="name"
                         value={ownerData.name}
                         onChange={handleInputChange}
                         placeholder="e.g. ABC Driving School"
                       />
                       {errors.name && (
                         <div className="invalid-feedback">{errors.name}</div>
                       )}
                     </div>

                     {/* Hotline */}
                     <div className="col-12 col-md-6">
                       <label
                         htmlFor="hotLine"
                         className="form-label fw-semibold"
                       >
                         {language?.hotline}
                       </label>
                       <input
                         type="text"
                         className={`form-control gld-input ${
                           errors.hotLine ? "is-invalid" : ""
                         }`}
                         id="hotLine"
                         value={ownerData.hotLine}
                         onChange={handleInputChange}
                         placeholder="0XXXXXXXXX"
                       />
                       {errors.hotLine && (
                         <div className="invalid-feedback">
                           {errors.hotLine}
                         </div>
                       )}
                     </div>

                     {/* Description */}
                     <div className="col-12">
                       <label
                         htmlFor="description"
                         className="form-label fw-semibold"
                       >
                         {language?.description}
                       </label>
                       <textarea
                         className={`form-control gld-input ${
                           errors.description ? "is-invalid" : ""
                         }`}
                         id="description"
                         value={ownerData.description}
                         onChange={handleInputChange}
                         rows={4}
                         placeholder="Write a short description (40–100 words)"
                       />
                       {errors.description && (
                         <div className="invalid-feedback">
                           {errors.description}
                         </div>
                       )}
                     </div>
                   </div>
                 </div>
               </div>

               {/* Services */}
               <div className="col-12">
                 <div className="gld-section">
                   <div className="d-flex align-items-center justify-content-between mb-2">
                     <label className="form-label fw-bold mb-0">
                       {language.service}
                     </label>
                     {errors.services && (
                       <small className="text-danger">{errors.services}</small>
                     )}
                   </div>

                   <div className="row g-2">
                     {[
                       { id: "all", name: language.allServices },
                       ...language.services,
                     ].map((serviceOption, index) => {
                       const isAll = serviceOption.id === "all";

                       const isChecked = isAll
                         ? ownerData.services.length ===
                             language.services.length &&
                           language.services.length > 0
                         : ownerData.services.some(
                             (s) => s.name === serviceOption.name,
                           );

                       return (
                         <div className="col-12 col-sm-6" key={index}>
                           <div className="form-check">
                             <input
                               className="form-check-input"
                               type="checkbox"
                               name={`service-${index}`}
                               id={`service-${index}`}
                               value={serviceOption.name}
                               checked={isChecked}
                               onChange={() => {
                                 if (isAll) {
                                   setOwnerData({
                                     ...ownerData,
                                     services: isChecked
                                       ? []
                                       : language.services.map((s) => ({
                                           id: s.id,
                                           name: s.name,
                                         })),
                                   });
                                   return;
                                 }

                                 const updatedServices = isChecked
                                   ? ownerData.services.filter(
                                       (s) => s.name !== serviceOption.name,
                                     )
                                   : [
                                       ...ownerData.services,
                                       {
                                         id: serviceOption.id,
                                         name: serviceOption.name,
                                       },
                                     ];

                                 setOwnerData({
                                   ...ownerData,
                                   services: updatedServices,
                                 });
                               }}
                             />
                             <label
                               className="form-check-label"
                               htmlFor={`service-${index}`}
                             >
                               {serviceOption.name}
                             </label>
                           </div>
                         </div>
                       );
                     })}
                   </div>
                 </div>
               </div>

               {/* Prices */}
               <div className="col-12">
                 <div className="gld-section">
                   <div className="d-flex align-items-center justify-content-between mb-2">
                     <label className="form-label fw-bold mb-0">
                       {language.price}
                     </label>
                     <button
                       type="button"
                       className="btn btn-outline-primary btn-sm align-self-end"
                       style={{ width: 32 }}
                       onClick={handleAddPrice}
                     >
                       +
                     </button>
                   </div>

                   {errors.prices && (
                     <small className="text-danger">{errors.prices}</small>
                   )}

                   <div className="mt-3">
                     {ownerData.prices.map((price, index) => (
                       <div className="gld-subcard mb-3" key={index}>
                         <div className="row g-3 align-items-end">
                           <div className="col-12 col-md-6">
                             <label className="form-label fw-semibold">
                               {language.selectVehicleType}
                             </label>
                             <select
                               className="form-select gld-input"
                               value={price.type}
                               onChange={(e) =>
                                 handleInputChange(e, index, "prices", "type")
                               }
                             >
                               <option disabled value="">
                                 Select...
                               </option>
                               {language.prices.map((vehicle, vIndex) => {
                                 const isUsed = ownerData.prices.some(
                                   (p, i) =>
                                     p.type === vehicle.type && i !== index,
                                 );

                                 return (
                                   <option
                                     key={vIndex}
                                     value={vehicle.type}
                                     disabled={isUsed}
                                   >
                                     {vehicle.type}
                                   </option>
                                 );
                               })}
                             </select>
                           </div>

                           <div className="col-12 col-md-5">
                             <label className="form-label fw-semibold">
                               {language.vehicalPrice}
                             </label>
                             <input
                               type="number"
                               className="form-control gld-input"
                               value={price.price}
                               onChange={(e) =>
                                 handleInputChange(e, index, "prices", "price")
                               }
                               placeholder="e.g. 2500"
                             />
                           </div>

                           {ownerData.prices.length > 1 && (
                             <div className="col-12 col-md-1">
                               <button
                                 type="button"
                                 className="btn btn-outline-danger align-self-end"
                                 style={{ width: 40 }}
                                 onClick={() => handleRemovePrice(index)}
                                 title="Remove"
                               >
                                 ✕
                               </button>
                             </div>
                           )}
                         </div>
                       </div>
                     ))}
                   </div>
                 </div>
               </div>

               {/* Branches */}
               <div className="col-12">
                 <div className="gld-section">
                   <div className="d-flex align-items-center justify-content-between mb-2">
                     <label className="form-label fw-bold mb-0">
                       {language.branch}
                     </label>
                     <button
                       type="button"
                       className="btn btn-outline-primary btn-sm align-self-end"
                       style={{ width: 32 }}
                       onClick={handleAddBranch}
                     >
                       +
                     </button>
                   </div>

                   {errors.branches && (
                     <small className="text-danger">{errors.branches}</small>
                   )}

                   <div className="mt-3">
                     {ownerData.branches.map((branch, index) => {
                       // UI-only improvement: show correct cities for selected district
                       const citiesForBranch =
                         cities[branch.district]?.cities || cityList;

                       return (
                         <div className="gld-subcard mb-3" key={index}>
                           <div className="d-flex align-items-center justify-content-between mb-2">
                             <div className="fw-semibold">
                               Branch {index + 1}
                             </div>
                             {ownerData.branches.length > 1 && (
                               <button
                                 type="button"
                                 className="btn btn-outline-danger btn-sm align-self-end"
                                 onClick={() => handleRemoveBranch(index)}
                                 style={{ width: 32 }}
                               >
                                 ✕
                               </button>
                             )}
                           </div>

                           <div className="row g-3">
                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.branchName}
                               </label>
                               <input
                                 type="text"
                                 id="branchName"
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_name_0`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 value={branch.branchName}
                                 onChange={(e) =>
                                   handleInputChange(e, index, "branches")
                                 }
                               />
                               {errors[`branch_${index}_name_0`] && (
                                 <div className="invalid-feedback">
                                   {errors[`branch_${index}_name_0`]}
                                 </div>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.branchAddress}
                               </label>
                               <input
                                 type="text"
                                 id="branchAddress"
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_address_0`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 value={branch.branchAddress}
                                 onChange={(e) =>
                                   handleInputChange(e, index, "branches")
                                 }
                               />
                               {errors[`branch_${index}_address_0`] && (
                                 <div className="invalid-feedback">
                                   {errors[`branch_${index}_address_0`]}
                                 </div>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.branchConNumber1}
                               </label>
                               <input
                                 type="text"
                                 id="branchContactNum"
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_phone_${0}`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 
                                 value={branch.branchContactNum[0]}
                                 onChange={(e) =>
                                   handleInputChange(
                                     e,
                                     index,
                                     "branches",
                                     null,
                                     0,
                                   )
                                 }
                               />
                               {errors[`branch_${index}_phone_${0}`] && (
                                 <small className="text-danger">
                                   {errors[`branch_${index}_phone_${0}`]}
                                 </small>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.branchConNumber2}
                               </label>
                               <input
                                 type="text"
                                 id="branchContactNum"
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_phone_${1}`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 value={branch.branchContactNum[1]}
                                 onChange={(e) =>
                                   handleInputChange(
                                     e,
                                     index,
                                     "branches",
                                     null,
                                     1,
                                   )
                                 }
                               />
                               {errors[`branch_${index}_phone_${1}`] && (
                                 <small className="text-danger">
                                   {errors[`branch_${index}_phone_${1}`]}
                                 </small>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.email}
                               </label>
                               <input
                                 type="email"
                                 id="email"
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_email_0`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 value={branch.email}
                                 onChange={(e) =>
                                   handleInputChange(e, index, "branches")
                                 }
                               />
                               {errors[`branches.${index}.email`] && (
                                 <small className="text-danger">
                                   {errors[`branches.${index}.email`]}
                                 </small>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.regNo}
                               </label>
                               <input
                                 type="text"
                                 id="regNo"
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_regNo_0`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 value={branch.regNo}
                                 onChange={(e) =>
                                   handleInputChange(e, index, "branches")
                                 }
                               />
                               {errors[`branch_${index}_regNo_0`] && (
                                 <small className="text-danger">
                                   {errors[`branch_${index}_regNo_0`]}
                                 </small>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.branchDistrict}
                               </label>
                               <select
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_district_0`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 value={branch.district}
                                 id="district"
                                 onChange={(e) =>
                                   handleInputChange(
                                     e,
                                     index,
                                     "branches",
                                     "district",
                                   )
                                 }
                               >
                                 <option value="" disabled>
                                   Select...
                                 </option>
                                 {Object.keys(cities).map((district, i) => (
                                   <option key={i} value={district}>
                                     {district}
                                   </option>
                                 ))}
                               </select>
                               {errors[`branch_${index}_district_0`] && (
                                 <small className="text-danger">
                                   {errors[`branch_${index}_district_0`]}
                                 </small>
                               )}
                             </div>

                             <div className="col-12 col-md-6">
                               <label className="form-label fw-semibold">
                                 {language.branchCity}
                               </label>
                               <select
                                 className={`form-control gld-input ${
                                   errors[`branch_${index}_city_0`]
                                     ? "is-invalid"
                                     : ""
                                 }`}
                                 id="city"
                                 value={branch.city}
                                 onChange={(e) =>
                                   handleInputChange(
                                     e,
                                     index,
                                     "branches",
                                     "city",
                                   )
                                 }
                                 disabled={!branch.district}
                               >
                                 <option value="" disabled>
                                   Select...
                                 </option>
                                 {citiesForBranch.map((city, i) => (
                                   <option key={i} value={city}>
                                     {city}
                                   </option>
                                 ))}
                               </select>
                               {errors[`branch_${index}_city_0`] && (
                                 <small className="text-danger">
                                   {errors[`branch_${index}_city_0`]}
                                 </small>
                               )}
                             </div>
                           </div>
                         </div>
                       );
                     })}
                   </div>
                 </div>
               </div>

               {/* Actions */}
               <div className="col-12">
                 <div className="gld-actions d-flex gap-2 justify-content-end">
                   <button
                     className="btn btn-outline-secondary px-4"
                     type="button"
                     onClick={() => navigate(-1)}
                   >
                     {language.back}
                   </button>
                   <button className="btn btn-warning text-white px-4" type="submit">
                     {language?.submit}
                   </button>
                 </div>
               </div>
             </form>
           </div>
         </div>
       </Container>
     </div>
   );

}

export default GetLearnersDetailsForm;
